// extracted by mini-css-extract-plugin
export default {"wrapper":"LocationsTab_wrapper__KBY+s","headerSectionWrapper":"LocationsTab_headerSectionWrapper__0aJrG","title":"LocationsTab_title__y0f9Q","ell":"LocationsTab_ell__AnlGj"};